module.exports = __webpack_public_path__ + "static/img/6.7f0aedc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/3/zh/6.png
// module id = GTP6
// module chunks = 0